export default __webpack_public_path__ + "static/geomanist-bold-webfont-7864df6d19eaf7764ee6bd8438e1373e.woff2";